export default __webpack_public_path__ + "static/media/LOGO-HENRY-04_w.73320d58.png";